import React, { useContext, useState } from "react";
import { CartContext } from "../Component/CartContext";
import "../css/checkout.css";
import productData from "../Datas/productData";
import { Link } from "react-router-dom";
import ReactFlagsSelect from "react-flags-select";

const CURRENCY = "GBP";

const CheckOut = () => {
  const { cartItems } = useContext(CartContext);
  const [formData, setFormData] = useState({
    email: "",
    countryCode: "",
    firstName: "",
    lastName: "",
    company: "",
    address: "",
    address1: "",
    city: "",
    postalCode: "",
  });
  const [errors, setErrors] = useState({});

  const getProductById = (id) =>
    productData.find((product) => product.id === id);

  const calculateTotal = () =>
    cartItems.reduce((total, item) => {
      const product = getProductById(item.id);
      if (!product) return total;
      return total + Number.parseFloat(product.price.replace(/,/g, "")) * item.quantity;
    }, 0);

  const updateField = (event) => {
    const { name, value } = event.target;
    setFormData((current) => ({ ...current, [name]: value }));
    setErrors((current) => ({ ...current, [name]: "" }));
  };

  const validateForm = () => {
    const nextErrors = {};
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailPattern.test(formData.email.trim())) nextErrors.email = "Enter a valid email address";
    if (!formData.countryCode) nextErrors.countryCode = "Select a country";
    if (!formData.firstName.trim()) nextErrors.firstName = "Enter a first name";
    if (!formData.lastName.trim()) nextErrors.lastName = "Enter a last name";
    if (!formData.address.trim()) nextErrors.address = "Enter an address";
    if (!formData.city.trim()) nextErrors.city = "Enter a city";
    if (!formData.postalCode.trim()) nextErrors.postalCode = "Enter a ZIP / postal code";
    if (cartItems.length === 0) nextErrors.cart = "Your cart is empty";

    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const createOrderNumber = () => {
    const randomValues = new Uint32Array(3);
    window.crypto.getRandomValues(randomValues);
    const randomDigits = Array.from(randomValues)
      .map((value) => String(value % 10000).padStart(4, "0"))
      .join("");
    return `${Date.now()}${randomDigits}`;
  };

  const handlePlaceOrder = (event) => {
    event.preventDefault();
    if (!validateForm()) return;

    const firstProduct = getProductById(cartItems[0].id);
    const paymentUrl = new URL("/create_payment.php", window.location.origin);
    paymentUrl.search = new URLSearchParams({
      orderNo: createOrderNumber(),
      amount: calculateTotal().toFixed(2),
      currency: CURRENCY,
      email: formData.email.trim(),
      success_url: `${window.location.origin}/payment?state=success`,
      cancel_url: `${window.location.origin}/payment?state=cancel`,
      title: firstProduct.name,
    }).toString();

    window.location.assign(paymentUrl.toString());
  };

  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  const total = calculateTotal();

  return (
    <main className="main-containerCheck">
      <div className="check-custom-checkout-page">
        <div className="left">
          <div className="check-order-info">
            <form onSubmit={handlePlaceOrder} noValidate>
              <div className="form-group">
                <label htmlFor="email">Contact</label>
                <input type="email" id="email" name="email" value={formData.email} placeholder="Email address" onChange={updateField} autoComplete="email" />
                {errors.email && <p className="error">{errors.email}</p>}
              </div>

              <div className="form-group">
                <label>Billing address</label>
                <ReactFlagsSelect
                  selected={formData.countryCode}
                  onSelect={(countryCode) => {
                    setFormData((current) => ({ ...current, countryCode }));
                    setErrors((current) => ({ ...current, countryCode: "" }));
                  }}
                  className="check-select"
                />
                {errors.countryCode && <p className="error">{errors.countryCode}</p>}
              </div>

              <div className="form-row">
                <div className="form-group">
                  <input name="firstName" value={formData.firstName} placeholder="First name *" onChange={updateField} autoComplete="given-name" />
                  {errors.firstName && <p className="error">{errors.firstName}</p>}
                </div>
                <div className="form-group">
                  <input name="lastName" value={formData.lastName} placeholder="Last name *" onChange={updateField} autoComplete="family-name" />
                  {errors.lastName && <p className="error">{errors.lastName}</p>}
                </div>
              </div>

              <div className="form-group">
                <input name="company" value={formData.company} onChange={updateField} placeholder="Company name (optional)" autoComplete="organization" />
              </div>
              <div className="form-group">
                <input name="address" value={formData.address} onChange={updateField} placeholder="Address *" autoComplete="address-line1" />
                {errors.address && <p className="error">{errors.address}</p>}
              </div>
              <div className="form-group">
                <input name="address1" value={formData.address1} onChange={updateField} placeholder="Apartment, suite, etc. (optional)" autoComplete="address-line2" />
              </div>
              <div className="form-row">
                <div className="form-group">
                  <input name="city" value={formData.city} placeholder="City *" onChange={updateField} autoComplete="address-level2" />
                  {errors.city && <p className="error">{errors.city}</p>}
                </div>
                <div className="form-group">
                  <input name="postalCode" value={formData.postalCode} placeholder="Postal code *" onChange={updateField} autoComplete="postal-code" />
                  {errors.postalCode && <p className="error">{errors.postalCode}</p>}
                </div>
              </div>

              {errors.cart && <p className="error">{errors.cart}</p>}
              <button type="submit" className="check-checkout-button" disabled={!cartItems.length}>Pay Now</button>
            </form>

            <p><Link to="/returns" style={{ textDecoration: "underline" }} onClick={toTop}>Shipping &amp; Returns Info</Link></p>
          </div>
        </div>

        <div className="right">
          <div className="check-order-summary">
            <div className="check-order-details">
              {cartItems.map((item, index) => {
                const product = getProductById(item.id);
                if (!product) return null;
                return (
                  <div key={`${item.id}-${item.size}-${item.color}-${item.chain}-${index}`} className="check-cart-item">
                    <img src={product.images?.[0] || product.image} alt={product.name} />
                    <div className="pro--qty"><div className="qty-inner">{item.quantity}</div></div>
                    <div className="check-item-details">
                      <h3>
                        {product.name}
                        {item.size && <><br />Size: {item.size}</>}
                        {item.color && <><br />Color: {item.color}</>}
                      </h3>
                    </div>
                    <p className="cal-single">£{(Number.parseFloat(product.price) * item.quantity).toFixed(2)}</p>
                  </div>
                );
              })}

              <div className="check-summary-details">
                <table className="summary-details22">
                  <tbody className="sumTbody22">
                    <tr className="sumTr22">
                      <th className="subtotalTh22" style={{ fontSize: "24px" }}>Total</th>
                      <th className="subtotalTxt22">£{total.toFixed(2)} {CURRENCY}</th>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default CheckOut;
